module.exports = __webpack_public_path__ + "_redirects";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=_redirects!./src/_redirects
// module id = 280
// module chunks = 0